import './mail-event-popin.component.ajscss';

import { IComponentController, IComponentOptions, ILogService } from 'angular';

import { IEpticaExctractEvent } from '../models/eptica-extract';
import templateUrl from './mail-event-popin.component.html';

class MailEventPopinCtrl implements IComponentController {
  close: Function;
  resolve: Function;

  epticaEvent: IEpticaExctractEvent;

  constructor(protected readonly $log: ILogService) {}

  $onInit(): void {
    this.epticaEvent = this.resolve().event;
  }
}

export class MailEventPopin implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    resolve: '&',
    close: '&',
  };
  controller = ['$log', MailEventPopinCtrl];
}

export default 'mailEventPopin';
